export const initial = {
  visible: false,
  name: '',
  saving: false
};

export default (state = initial, action = {}) => {
  switch (action.type) {
    case 'CREATE_RANKING_SAVING':
      return { ...state, saving: true };
    case 'CREATE_RANKING_NAME':
      return { ...state, name: action.payload };
    case 'CREATE_RANKING_VISIBLE':
      return { ...state, visible: action.payload };
    case 'CREATE_RANKING_CLEAR':
      return initial;
    default:
      return state;
  }
};
